import { useEffect, useState } from 'react'

import {
  DEMO_STEP_PLAYBACK_COMPLETE_EVENT,
} from './playback-constants'

export const useDemoStepPlaybackComplete = (step: DemoCalculatorStep) => {
  const [ isComplete, setIsComplete ] = useState(false)

  useEffect(() => {
    const handleComplete = (event: Event) => {
      const completedStep = (event as CustomEvent<{ step: DemoCalculatorStep }>).detail?.step

      if (completedStep === step) {
        setIsComplete(true)
      }
    }

    window.addEventListener(DEMO_STEP_PLAYBACK_COMPLETE_EVENT, handleComplete)

    return () => window.removeEventListener(DEMO_STEP_PLAYBACK_COMPLETE_EVENT, handleComplete)
  }, [ step ])

  return isComplete
}
